import { render, staticRenderFns } from "./WorkDetail2.vue?vue&type=template&id=34f2b906&scoped=true&"
import script from "./WorkDetail2.vue?vue&type=script&lang=js&"
export * from "./WorkDetail2.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail2.vue?vue&type=style&index=0&id=34f2b906&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2b906",
  null
  
)

export default component.exports